import { collections } from './routesCollections.access';
import { contents } from './routesContents.access';
import { fixedLayout } from './routesFixedLayout.access';
import { isFTD } from './routesFTD.access';
import { licenses } from './routesLicenses.access';
import { licensesBatch } from './routesLicensesBatch.access';
import { messages } from './routesLicensesMessages.access';
import { personalize } from './routesPersonalize.access';
import { programs } from './routesPrograms.access';
import { publications } from './routesPublications.access';
import { schools } from './routesSchools.access';
import { settingsApp } from './routesSettings.access';
import { tools } from './routesTools.access';
import { users } from './routesUsers.access';

export function canAccess({ flags, path, settings, user }) {
  const accessChecks = [
    () => collections(path, user),
    () => contents(path, user),
    () => fixedLayout(path, user, settings),
    () => isFTD(user, path),
    () => licenses(path, user),
    () => licensesBatch(path, user),
    () => messages({ flags, path }),
    () => personalize(path, user),
    () => programs(path, user),
    () => publications(path, user),
    () => schools(path, user),
    () => settingsApp(path, user, settings),
    () => tools(path, user),
    () => users(path, user),
  ];

  return accessChecks.every((check) => check());
}
